<template>
  <div class="news-content">
    <div class="news-tab">
      <div class="news-tab__left">
        <div
          v-for="(item, key) in newsType"
          :key="key"
          class="news-tab__item"
          :class="getTabClass(key, item)"
          @click="changeTab(item.type)"
        >
          <div class="image"></div>
          <div class="news-tab__seperator" v-if="key != newsType.length - 1"></div>
        </div>
      </div>
      <div class="news-tab__right">
        <div class="btn-more" @click="viewList">MORE</div>
      </div>
    </div>
    <div class="news-list">
      <template v-for="(newsItem, newsType) in newsList">
        <div
          :key="newsType"
          class="box"
          v-if="activeTab == newsType"
        >
          <ul>
            <li
              v-for="(item, key) in newsItem"
              :key="key"
              class="news-item"
            >
              <span class="tag">{{ item.tag }}</span>
              <span class="title" :title="item.title" @click="viewNews(item)">{{ item.title }}</span>
              <span class="time">{{ item.time }}</span>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import newsListMixins from '@/mixins/home/newsListMixins.js'

export default {
  mixins: [newsListMixins],
}
</script>

<style lang="scss" scoped>
.news-content {
  width: 532px;
}

.news-tab {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 26px;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    width: 100%;
    height: 1px;
    background: #c3ad99;
  }

  &__left {
    display: flex;
    align-items: center;
  }

  &__item {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    cursor: pointer;

    .image {
      width: 90px;
      height: 48px;
      background: url('~@/assets/img/pc/news_type.png') no-repeat;
    }
  }

  &--active {
    background: url('~@/assets/img/pc/news_type_active.png') no-repeat;
    background-position: left bottom;
  }

  &__seperator {
    transform: rotate(45deg);
    margin-left: 4px;
    width: 7px;
    height: 7px;
    background: #9a7b62;
  }

  &__type {
    &-latest .image {
      background-position: 0 0;
    }
    &-news .image {
      background-position: 0 -48px;
    }
    &-tips .image {
      background-position: 0 -96px;
    }
    &-activity .image {
      background-position: 0 -144px;
    }
  }

  &__right {
    display: flex;
    align-items: center;
  }

  .btn-more {
    display: flex;
    align-items: center;
    width: 72px;
    height: 28px;
    color: #978d88;
    background: url('~@/assets/img/pc/news_more.png') no-repeat;
    background-position: center right;
    cursor: pointer;
  }
}

.news-list {
  .box {
    width: 100%;
    height: 282px;

    ul {
      overflow: hidden;
      width: 100%;
      height: 100%;
    }

    li {
      display: flex;
      align-items: center;
    }

    .tag {
      margin-right: 22px;
      width: 46px;
      height: 26px;
      text-align: center;
      line-height: 26px;
      color: #fff;
      background: #388176;
    }

    .title {
      flex: 1;
      color: #584c45;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;

      &:hover {
        color: #388176;
      }
    }

    .time {
      width: 78px;
      color: #978d88
    }
  }
}

.news-item {
  padding: 10px 0;
  border-bottom: 1px dashed #c6b5a5;
}
</style>